import { render, staticRenderFns } from "./Mailliste.vue?vue&type=template&id=53e4c1ea&"
import script from "./Mailliste.vue?vue&type=script&lang=js&"
export * from "./Mailliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports